export const parseVerticalGeometry = (data) => {

    if(!data) return null;

    const NYL = detectNYLFormat(data);
    const QAC = detectQACFormat(data);
    const C3D = detectC3DFormat(data);

    if(NYL) return NYL;

    if(QAC) return QAC;

    if(C3D) return C3D;
    
    /*let parsedGeometry = [];
    data = data.trim().split("\n");
    data.forEach(el => {
        let object = el.trim().split("\t")
        let temp = {};

        temp.number = Number(object[0]);
        temp.type = object[1];
        temp.startStationing = Number(object[14]);
        temp.startElevation = Number(object[15]);
        temp.endStationing = Number(object[16]);
        temp.endElevation = Number(object[17]);
        temp.length = Number(object[9]);

        if(temp.type === "Rettlinje")
        {   
            temp.stationingPoints = [temp.startStationing, temp.endStationing];
            temp.elevationPoints = [temp.startElevation, temp.endElevation];
            temp.slopes = [(temp.endElevation - temp.startElevation)/(temp.endStationing - temp.startStationing), (temp.endElevation - temp.startElevation)/(temp.endStationing - temp.startStationing)];
            temp.slope = Number(((temp.endElevation - temp.startElevation)/(temp.endStationing - temp.startStationing)));
        }
        else if(temp.type === "Sirkelbue")
        {
            temp.radius = Number(object[4]);
            temp.stationingPoints = [];
            temp.elevationPoints = [];
            temp.slopes = [];

            let center = [0, 0];
            let centerPrim = [temp.startStationing + 0.5 * (temp.endStationing - temp.startStationing), temp.startElevation + 0.5 * (temp.endElevation - temp.startElevation)];
            
            let radiusDelta = Math.sqrt(temp.radius**2 - 0.25 * ((temp.endStationing - temp.startStationing)**2 + (temp.endElevation - temp.startElevation)**2));
            
            let pointsDistance = Math.sqrt((temp.endStationing - temp.startStationing)**2 + (temp.endElevation - temp.startElevation)**2);
            let vector = [radiusDelta * (temp.endStationing - temp.startStationing)/pointsDistance, radiusDelta * (temp.endElevation - temp.startElevation)/pointsDistance];
            
            if(temp.radius < 0) center = [centerPrim[0] - vector[1], centerPrim[1] + vector[0]];
            else center = [centerPrim[0] + vector[1], centerPrim[1] - vector[0]];

            let N = 500;
            let theta = Math.atan2((temp.startStationing - center[0]) * (temp.endElevation - center[1]) - (temp.startElevation - center[1]) * (temp.endStationing - center[0]), (temp.startStationing - center[0]) * (temp.endStationing - center[0]) + (temp.startElevation - center[1]) * (temp.endElevation - center[1]));
            let directionalVector = [temp.startStationing - center[0], temp.startElevation - center[1]];
            for(let i = 0; i<=N; i++)
            {
                temp.stationingPoints.push(center[0] + directionalVector[0] * Math.cos(i * theta/N) - directionalVector[1] * Math.sin(i * theta/N)); 
                temp.elevationPoints.push(center[1] + directionalVector[0] * Math.sin(i * theta/N) + directionalVector[1] * Math.cos(i * theta/N));
                temp.slopes.push(
                    ((center[1] + directionalVector[0] * Math.sin((i+1) * theta/N) + directionalVector[1] * Math.cos((i+1) * theta/N)) - (center[1] + directionalVector[0] * Math.sin(i * theta/N) + directionalVector[1] * Math.cos(i * theta/N)))
                    /
                    ((center[0] + directionalVector[0] * Math.cos((i+1) * theta/N) - directionalVector[1] * Math.sin((i+1) * theta/N)) - (center[0] + directionalVector[0] * Math.cos(i * theta/N) - directionalVector[1] * Math.sin(i * theta/N)))
                );
            }   
        }
        parsedGeometry.push(temp);
    })

    let parseTestResult = true;

    for(let i = 0; i < parsedGeometry.length; i++)
    {
        if(parsedGeometry[i].type)
        {
            if(parsedGeometry[i].type !== "Rettlinje" && parsedGeometry[i].type !== "Sirkelbue") parseTestResult = false;
        }
        else parseTestResult = false;

        if(parsedGeometry[i+1] && parseTestResult)
        {
            if(parsedGeometry[i].number !== parsedGeometry[i+1].number - 1) parseTestResult = false;
            if(parsedGeometry[i].endStationing !== parsedGeometry[i+1].startStationing) parseTestResult = false
            if(parsedGeometry[i].endElevation !== parsedGeometry[i+1].startElevation) parseTestResult = false
        }
    }

    if(parseTestResult) return parsedGeometry;
    else return null;*/
}

const detectNYLFormat = (data) => {
    let geometryData = [];
    let validPoints = [];
    let breakPoints = [];

    // #region validation of NYL

    const lines = data.split(/\r?\n/).map(l => l.trim());

    const NYLNumberFormat = '-?\\d+(?:\\.\\d+)?';
    const NYLRowFormat = new RegExp(`^\\s*(${NYLNumberFormat})\\s+(${NYLNumberFormat})\\s+(${NYLNumberFormat})\\s*$`);

    const rows = lines.filter(l => NYLRowFormat.test(l)).map(l => {
        const m = l.match(NYLRowFormat);
        return ([Number(m[1]), Number(m[2]), Number(m[3])]);
    });

    const findControlLine = () => {
        let validRows = [...rows];
        let index = null;
        const xArray = rows.map(r => r[0]);
        const xMin = Math.min(...xArray);
        const xMax = Math.max(...xArray);

        rows.forEach((r, i) => {
            if(r[0] <= xMin && r[2] >= xMax && r[1] !== 0) index = i;
        });

        if(index !== null) validRows.splice(0, index + 1);
        
        return validRows;
    }


    if(rows.length !== 0)
    {
        const dataPoints = findControlLine();
        

        for(let i = 0; i <dataPoints.length; i++)
        {
            let prev = dataPoints[i - 1] || null;
            
            if(!prev)
            {
                validPoints.push(dataPoints[i]);
                continue;
            }

            let [px, py, pr] = prev;
            let [x, y, r] = dataPoints[i];

            if(x > px) validPoints.push(dataPoints[i]);
            else if(x === px && y === py && r === 0 && pr === 0) continue;
            else return null;
        }
    }

    // #endregion

    if(validPoints.length === 0) return null;


    // #region generating geometry data

    for(let i = 1; i < validPoints.length-1; i++)
    {
        const radius = validPoints[i][2];
        const a = {stationing: validPoints[i-1][0], elevation: validPoints[i-1][1]}
        const b = {stationing: validPoints[i][0], elevation: validPoints[i][1]}
        const c = {stationing: validPoints[i+1][0], elevation: validPoints[i+1][1]}

        if(radius === 0)
        {
            breakPoints.push({
                type: 'break',
                stationing: b.stationing,
                elevation: b.elevation
            });
        }
        else
        {
            let u = {
                x: a.stationing - b.stationing,
                y: a.elevation - b.elevation
            }

            u = {
                x: u.x / Math.sqrt(u.x**2 + u.y**2),
                y: u.y / Math.sqrt(u.x**2 + u.y**2)
            }

            let v = {
                x: c.stationing - b.stationing,
                y: c.elevation - b.elevation
            }

            v = {
                x: v.x / Math.sqrt(v.x** 2 + v.y**2),
                y: v.y / Math.sqrt(v.x** 2 + v.y**2)
            }

            let w = {
                x: u.x + v.x,
                y: u.y + v.y
            }

            w = {
                x: w.x / Math.sqrt(w.x** 2 + w.y**2),
                y: w.y / Math.sqrt(w.x** 2 + w.y**2)
            }

            const acos = Math.acos((u.x * v.x) + (u.y * v.y))
            
            const deltaT = Math.abs(radius)/Math.tan(0.5 * acos);

            const s1 = u.y/u.x;
            const s2 = v.y/v.x;

            breakPoints.push(
                {
                    type: 'arcStart',
                    radius: s1 >= s2 ? radius : -radius,
                    stationing: b.stationing + deltaT * u.x,
                    elevation: b.elevation + deltaT * u.y,
                },
                {
                    type: 'arcEnd',
                    radius: s1 >= s2 ? radius : -radius,
                    stationing: b.stationing + deltaT * v.x,
                    elevation: b.elevation + deltaT * v.y,
                }
            );
        }
    }

    if(breakPoints[0].stationing > data[0][0])
    {
        geometryData.push({
            type: 'line',
            startStationing: validPoints[0][0],
            startElevation: validPoints[0][1],

            endStationing: breakPoints[0].stationing,
            endElevation: breakPoints[0].elevation,

            radius: null,
            slope: (breakPoints[0].elevation - validPoints[0][1])/(breakPoints[0].stationing - validPoints[0][0])
        });
    }

    for(let i = 0; i < breakPoints.length-1; i++)
    {
        if(breakPoints[i].type === 'arcStart' && breakPoints[i+1].type === 'arcEnd')
        {
            geometryData.push({
                type: 'arc',
                startStationing: breakPoints[i].stationing,
                startElevation: breakPoints[i].elevation,
                
                endStationing: breakPoints[i+1].stationing,
                endElevation: breakPoints[i+1].elevation,

                radius: breakPoints[i].radius,
                slope: null
            });
        }
        else if(breakPoints[i].type === 'arcEnd' && breakPoints[i+1].type === 'arcStart')
        {
            geometryData.push({
                type: 'line',
                startStationing: breakPoints[i].stationing,
                startElevation: breakPoints[i].elevation,

                endStationing: breakPoints[i+1].stationing,
                endElevation: breakPoints[i+1].elevation,

                radius: null,
                slope: (breakPoints[i+1].elevation - breakPoints[i].elevation)/(breakPoints[i+1].stationing - breakPoints[i].stationing)
            });
        }
        else if(breakPoints[i].type === 'break' && breakPoints[i+1].type === 'arcStart')
        {
            geometryData.push({
                type: 'line',
                startStationing: breakPoints[i].stationing,
                startElevation: breakPoints[i].elevation,

                endStationing: breakPoints[i+1].stationing,
                endElevation: breakPoints[i+1].elevation,

                radius: null,
                slope: (breakPoints[i+1].elevation - breakPoints[i].elevation)/(breakPoints[i+1].stationing - breakPoints[i].stationing)
            });
        }
        else if(breakPoints[i].type === 'arcEnd' && breakPoints[i+1].type === 'break')
        {
            geometryData.push({
                type: 'line',
                startStationing: breakPoints[i].stationing,
                startElevation: breakPoints[i].elevation,

                endStationing: breakPoints[i+1].stationing,
                endElevation: breakPoints[i+1].elevation,

                radius: null,
                slope: (breakPoints[i+1].elevation - breakPoints[i].elevation)/(breakPoints[i+1].stationing - breakPoints[i].stationing)
            });
        }
        else if(breakPoints[i].type === 'break' && breakPoints[i+1].type === 'break')
        {
            geometryData.push({
                type: 'line',
                startStationing: breakPoints[i].stationing,
                startElevation: breakPoints[i].elevation,

                endStationing: breakPoints[i+1].stationing,
                endElevation: breakPoints[i+1].elevation,

                radius: null,
                slope: (breakPoints[i+1].elevation - breakPoints[i].elevation)/(breakPoints[i+1].stationing - breakPoints[i].stationing)
            });
        }
    }

    if(breakPoints[breakPoints.length-1].stationing < validPoints[validPoints.length-1][0])
    {
        geometryData.push({
            type: 'line',
            startStationing: breakPoints[breakPoints.length-1].stationing,
            startElevation: breakPoints[breakPoints.length-1].elevation,

            endStationing: validPoints[validPoints.length-1][0],
            endElevation: validPoints[validPoints.length-1][1],

            radius: null,
            slope: (validPoints[validPoints.length-1][1] - breakPoints[breakPoints.length-1].elevation)/(validPoints[validPoints.length-1][0] - breakPoints[breakPoints.length-1].stationing)
        });
    }

    // #endregion
    
    return geometryData.length !== 0 ? geometryData : null;


}

const detectQACFormat = (data) => {
    let geometryData = [];

    const isNummeric = (value) => {
        return !Number.isNaN(Number(value));
    }

    // #region validation of QAC
    const lines = data.trim().split(/\r?\n/).map(l => l.trim());
    const rows = lines.map(l => l.trim().split(/\t/));

    for(let i = 0; i<rows.length; i++)
    {
        const r = rows[i];
        if(!['Rettlinje', 'Sirkelbue', 'Line', 'Arc'].includes(r[1]) 
        || !isNummeric(r[14])
        || !isNummeric(r[15])
        || !isNummeric(r[16])
        || !isNummeric(r[17])
        || !isNummeric(r[4]))
        {
            return null;
        }

        geometryData.push({
            type: r[1] === 'Rettlinje' || r[1] === "Line" ? 'line' : 'arc',
            startStationing: Number(r[14]),
            startElevation: Number(r[15]),
            endStationing: Number(r[16]),
            endElevation: Number(r[17]),

            radius: r[1] === 'Arc' || r[1] === "Sirkelbue" ? Number(r[4]) : null,
            slope: r[1] === "Rettlinje" || r[1] === 'Line' ? 
                (Number(r[17]) - Number(r[15])) / (Number(r[16]) - Number(r[14]))
                : null
        })
    }

    for(let i = 0; i<geometryData.length-1; i++)
    {
        const a = geometryData[i];
        const b = geometryData[i+1];

        if(a.endStationing !== b.startStationing || a.endElevation !== b.startElevation) return null;
    }

    return geometryData;

}

const detectC3DFormat = (data) => {
    let C3D = {
        valid: false,
        rows: null,
    }

    return C3D;
}
